const PERSISTED_AUTH_KEY = "auth";
const TOKEN_KEYS = ["refresh_token", "access_token", "id_token"];
const DEFAULT_AUTH_REFRESH_MODE = "legacy";

export function isCookieRefreshEnabled(authRefreshMode = DEFAULT_AUTH_REFRESH_MODE) {
  return authRefreshMode === "cookie";
}

export function getAuthPersistedState(state) {
  const persistedState = {
    auth_refresh_mode: state.auth_refresh_mode || DEFAULT_AUTH_REFRESH_MODE,
    user_info: state.user_info,
    userEmailInput_remembered: state.userEmailInput_remembered,
  };

  if (!isCookieRefreshEnabled(state.auth_refresh_mode)) {
    persistedState.refresh_token = state.refresh_token;
    persistedState.access_token = state.access_token;
    persistedState.id_token = state.id_token;
  }

  return persistedState;
}

export function purgePersistedAuthTokens(storage = window.localStorage) {
  if (!storage) return;

  const rawAuth = storage.getItem(PERSISTED_AUTH_KEY);
  if (!rawAuth) return;

  try {
    const auth = JSON.parse(rawAuth);
    if (!isCookieRefreshEnabled(auth.auth_refresh_mode)) return;

    let hasToken = false;

    TOKEN_KEYS.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(auth, key)) {
        delete auth[key];
        hasToken = true;
      }
    });

    if (hasToken) {
      storage.setItem(PERSISTED_AUTH_KEY, JSON.stringify(auth));
    }
  } catch {
    storage.removeItem(PERSISTED_AUTH_KEY);
  }
}

export function applyAuthTokensFromResponse(store, data = {}) {
  const token = data.token || data;
  const accessToken = token.access_token || token.accessToken;
  const idToken = token.id_token || token.idToken;

  if (accessToken) {
    store.commit("setAccessToken", accessToken);
  }
  if (idToken) {
    store.commit("setIdToken", idToken);
  }
}

export function getCookieRefreshConfig() {
  return { skipAuth: true, withCredentials: true };
}

export function getRefreshTokenConfig(refreshToken, authRefreshMode = DEFAULT_AUTH_REFRESH_MODE) {
  if (isCookieRefreshEnabled(authRefreshMode)) {
    return getCookieRefreshConfig();
  }

  return {
    skipAuth: true,
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  };
}
